import type { Permission } from '@ztechapps/common.contract'

export const panelpunchesPermissions = {
  storeBack: {
    canAccess: {
      value: 'storeBack.canAccess',
      label: 'Can Access',
      description: 'Set the permission of the user whether to enable access to store backend application or not',
    } satisfies Permission,
  },

  // The admin and API copies of this description diverged; this is the API's wording,
  // the one this permission actually gates at the route level.
  storeFront: {
    canAccess: {
      value: 'storeFront.canAccess',
      label: 'Can Access',
      description: 'Can access the www.panelpunches.com website.',
    } satisfies Permission,
  },

  adminMobile: {
    canAccess: {
      value: 'adminMobile.canAccess',
      label: 'Can Access',
      description: 'Set the permission of the user whether to enable access to the admin mobile application or not',
    } satisfies Permission,
  },
}
